import { add, type Dinero } from "dinero.js"

import { toDinero } from "../../../../currency/currencyLib"

import { InvoiceLinesType, SubscriptionInvoiceLines, TransactionInvoiceLines } from "../adminInvoicingTypes"

type Totals = {
    [key in InvoiceLinesType]?: Dinero<number>
}
type TotalsWithOverall = Totals & {
    overallTotal?: Dinero<number>
}

const addOrStart = (sum: Dinero<number> | undefined, amount: Dinero<number>) => (sum ? add(sum, amount) : amount)

export function calculateTotals(
    invoiceLines: (TransactionInvoiceLines | SubscriptionInvoiceLines)[],
): TotalsWithOverall {
    const totals = invoiceLines.reduce<Totals>((acc, line) => {
        acc[line.type] = addOrStart(acc[line.type], toDinero(line.totalAmount))
        return acc
    }, {})
    const overallTotal = Object.values(totals).reduce<Dinero<number> | undefined>(
        (sum, amount) => (amount ? addOrStart(sum, amount) : sum),
        undefined,
    )

    return { ...totals, overallTotal }
}
